/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import { useState, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../setup';
import DateValue from '../components/DateValue';
import DivideValue from '../components/DivideValue';
import PickerValue from '../components/PickerValue';
import DateTimeValue from './DateTimeValue';
import TabCheckboxValue from './TabCheckboxValue';
import TabHtmlview from './TabHtmlview';
import TabTextField2 from './TabTextField2';
import IpadTypeField from './iPadTypeField';

var XMLParser = require('react-xml-parser');

const TabTableItem2 = (props: any) => {
    const { indexing, headers, data, definitions, handleChange } = props;
    const [odd, setOdd] = useState<boolean>(false);
    const [background, setBackground] = useState<string>("");
    const rights: any = useSelector<RootState>(({ auth }: any) => auth.rights, shallowEqual);

    useEffect(() => {
        if (indexing % 2 === 0) {
            setOdd(true)
        } else {
            setOdd(false)
        }
    }, [indexing])

    const handleClick = () => {

    }

    useEffect(() => {
        if (odd) {
             setBackground("bg-gray-100 text-gray-700");
        } else {
            setBackground("text-gray-700")
        }
        // eslint-disable-next-line
    }, [data, odd])
    
    return (
        <tr className={background}>
            {
                headers.map((item: any, index: number) => {
                    const definition = definitions[index].definition;
                    // const option = options[index]
                    const xml = new XMLParser().parseFromString(definition);
                    const filter = xml.children.filter((item: any) => item.name === 'objecttype')
                    let objectType = "";
                    if (filter[0]) {
                        objectType = filter[0].value;
                    } else {
                        // console.log("Not fount objectType => ", xml);
                    }
                    if (objectType === 'picker') {
                        return (
                            <PickerValue
                                key={index}
                                header={item.toLowerCase()}
                                datas={data[item.toLowerCase()]}
                                handleClick={handleClick}
                                definition={xml.children}
                            />
                        )
                    }
                    else if (objectType === 'date') {
                        return (
                            <DateValue
                                key={index}
                                header={item.toLowerCase()}
                                datas={data[item.toLowerCase()]}
                                handleClick={handleClick}
                                definition={xml.children}
                            />
                        )
                    }
                    else if (objectType === 'popup') {
                        return (
                            <IpadTypeField
                                key={index}
                                index={indexing}
                                header={item.toLowerCase()}
                                datas={data[item.toLowerCase()]}
                                handleClick={handleClick}
                                definition={xml.children}
                            />
                        )
                    }
                    else if (objectType === 'checkbox') {
                        return (
                            <TabCheckboxValue
                                key={index}
                                odd={true}
                                value={data[item.toLowerCase()]}
                            />
                        )
                    }
                    else if (objectType === 'html') {
                        return (
                            <TabHtmlview
                                key={index}
                                data={data[item.toLowerCase()]}
                                handleClick={handleClick}
                            />
                        )
                    }
                    else if (objectType === 'datetime') {
                        return (
                            <DateTimeValue
                                key={index}
                                header={item.toLowerCase()}
                                datas={data[item.toLowerCase()]}
                                handleClick={handleClick}
                                definition={xml.children}
                            />
                        )
                    }

                    else if (objectType === 'divide') {
                        return (
                            <DivideValue
                                key={index}
                                data={data}
                                handleClick={handleClick}
                            />
                        )
                    }
                    else if (objectType === 'textbox') {
                        return (
                            <TabTextField2
                                key={index}
                                index={index}
                                name={item.toLowerCase()}
                                data={data}
                                disabled={rights['admin_ownsystem'] ? false: true}
                                handleClick={handleClick}
                                definition={xml.children}
                                handleChange={handleChange}
                            />
                        )
                    }
                    else if (objectType === 'resultcode') {
                        return (
                            <td key={index} style={{ padding: '0px 10px', overflow: 'hidden', height: 40 }}
                                onClick={handleClick}
                            >
                                <a className='text-dark  text-hover-primary d-block ' style={{ cursor: 'pointer', wordBreak: 'break-all', fontWeight: 500, color: '#3F4254', fontSize: '13px', }}>
                                    {
                                        +data[item.toLowerCase()] === 0 ?
                                        "OK" : "Error"
                                    }
                                </a>
                            </td>
                        )
                    }
                    else if (objectType === 'yesorno') {
                        return (
                            <td key={index} style={{ padding: '0px 10px', overflow: 'hidden', height: 40 }}
                                onClick={handleClick}
                            >
                                <a className='text-dark  text-hover-primary d-block ' style={{ cursor: 'pointer', wordBreak: 'break-all', fontWeight: 500, color: '#3F4254', fontSize: '13px', }}>
                                    {
                                        +data[item.toLowerCase()]  ?
                                        "Yes" : "No"
                                    }
                                </a>
                            </td>
                        )
                    }
                    else {
                        return (
                            <td key={index} style={{ padding: '0px 10px', overflow: 'hidden', height: 40 }}
                                onClick={handleClick}
                            >
                                <a className='text-dark  text-hover-primary d-block text-gray-700' style={{ cursor: 'pointer', wordBreak: 'break-all', fontWeight: 500, color: '#3F4254', fontSize: '13px', }}>
                                    {
                                        data[item.toLowerCase()]
                                    }
                                </a>
                            </td>
                        )
                    }
                })
            }
            <td style={{ width: '100%', minWidth: '0px', height: 40, padding: '0px 0px 0px 0px ' }}>
                <div className='d-flex justify-content-center'>
                </div>
            </td>
        </tr >
    )
}

export default TabTableItem2;